// Date helpers shared by the billing surfaces (Billing, PlanPicker,
// FreePeriodBanner). Moved out of Billing.tsx so the free-period countdown
// and the trial countdown round the same way.

/** "Oct 30, 2026" in the viewer's locale. */
export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

/**
 * Whole days until `iso`, rounded up: 1 means anywhere from a minute to 24
 * hours left, which is why copy says "less than a day" rather than
 * "tomorrow". 0 or less once it has passed.
 */
export function daysUntil(iso: string, now: number = Date.now()): number {
  const target = new Date(iso).getTime();
  return Math.ceil((target - now) / (1000 * 60 * 60 * 24));
}
